import React from 'react'

import { Award } from '../../../Recommendations/components/Award/Award'

export const Bonus = ({ bonus }: { bonus?: number }) => {
  if (!bonus) return null

  return <Award value={bonus} currency="USD" text=" sample credit" />
}
